// Progression bar animations from click
$(function() {
    let steps = $('.stage-number-container').outerWidth(),
        last = false,
        currentClass,
        currentStep,
        prevStep,
        nextStep

    $(window).on('load', function(){
        $('.step-1').addClass('active')
        $('.stage-number-arrow-helper').css('left', steps * 1.5 - 40 + 'px').addClass('active')
        $('.stage-number-arrow').css('left', steps * 1.5 - 21 + 'px')
    })

    $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize){
        if(newSize != 'small' || newSize != 'medium') {
            // recalc width on resize since it will be zero for mobile since it is hidden
            steps = $('.stage-number-container').outerWidth()
            $('.step-1').addClass('active')
            $('.stage-number-arrow-helper').css('left', steps * 1.5 - 40 + 'px').addClass('active')
            $('.stage-number-arrow').css('left', steps * 1.5 - 21 + 'px')
        }
    })

    function arrow(el){
        el.removeClass(currentClass).addClass('step-' + nextStep).css('left', (currentStep * steps) + (steps/2) - 18 + 'px')
        $('.stage-number-title.step-' + prevStep).removeClass('current')
        $('.stage-number-title.step-' + currentStep).addClass('active current')
        $('.stage-number-container.step-' + prevStep).removeClass('current')
        $('.stage-number-container.step-' + currentStep).addClass('active current')
        $('.stage-number-content.step-' + prevStep).removeClass('current')
        $('.stage-number-content.step-' + currentStep).addClass('active current')
    }

    $('.stage-number-arrow').on('click', function(){
        $('.stage-number-arrow .far').removeClass('bounce')
        $('.stage-number-arrow-helper').remove()

        let $this = $(this),
            arrowClasses = $this.attr('class').split(/\s+/)

        $.each(arrowClasses, function(i, val){
            if(val.indexOf('step-') > -1) {
                currentClass = val
                currentStep = parseInt(val.split('-')[1])
                prevStep = currentStep - 1
                nextStep = currentStep + 1
            } else if(val.indexOf('last') > -1 ) {
                last = true
            }
        })

        // Progression animation
        if($('.stage-number-container:nth-last-child(2)').hasClass('current')) {
            arrow($this)
            $('.stage-number-arrow').remove();
        } else {
            arrow($this)
        }
    })

})